/* eslint-disable one-var */
import { PropTypes } from 'react';
import { task, call } from 'react-task';
import { delay } from 'react-task/promises';
import SoundManager from 'es6/services/sound-manager';
import { CORRECT } from 'es6/core/sound-effects';

export const
  ANIMATION_START                            = 0,
  ANIMATION_FADE_IN_SENTENCE                 = 1,
  ANIMATION_FADE_IN_SENTENCE_END             = 2,
  ANIMATION_PLAY_SENTENCE                    = 3,
  ANIMATION_FADE_IN_SENTENCE_TRANSLATION     = 4,
  ANIMATION_FADE_IN_SENTENCE_TRANSLATION_END = 5,
  ANIMATION_END                              = 6;

export function* fadeInSentence(getProps) {
  const { setAnimationState, sentence } = yield call(getProps);

  // Play sound effect and wait for it to finish playing.
  yield call(playEffectPromise, CORRECT);

  if (sentence) {
    // Fade in sentence and wait for the transition to end.
    yield call(setAnimationState, ANIMATION_FADE_IN_SENTENCE);
    // Wait until the props match the filter.
    yield call(getProps, ({ animationState }) => animationState === ANIMATION_FADE_IN_SENTENCE_END);

    // Play the audio for the sentence and wait for it to finish.
    if (sentence.soundUrl) {
      yield call(setAnimationState, ANIMATION_PLAY_SENTENCE);
      yield call(playSoundPromise, sentence.soundUrl);
    }

    if (sentence.translation) {
      // Delay before showing the sentence translation and then fade it in.
      yield call(delay, 500);
      yield call(setAnimationState, ANIMATION_FADE_IN_SENTENCE_TRANSLATION);

      // Wait until animation finishes.
      yield call(getProps, ({ animationState }) => animationState === ANIMATION_FADE_IN_SENTENCE_TRANSLATION_END);
    }
  }

  yield call(setAnimationState, ANIMATION_END);
}

const FadeInSentenceTask = task(fadeInSentence);

FadeInSentenceTask.propTypes = {
  setAnimationState: PropTypes.func.isRequired,
  animationState:    PropTypes.number.isRequired,
  sentence:          PropTypes.shape({
    text:        PropTypes.string,
    translation: PropTypes.string,
    soundUrl:    PropTypes.string,
  }),
};

export default FadeInSentenceTask;

// Side effect helper functions that return promises for use inside the task generator function.
export function playEffectPromise(url) {
  return new Promise((resolve, reject) => {
    SoundManager.playEffect(url, { finished: resolve });
  });
}

export function playSoundPromise(url) {
  return new Promise((resolve, reject) => {
    SoundManager.play(url, { finished: resolve });
  });
}
